import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { ConfiguracaoEmailResponse } from "types/response/groupPay/ConfiguracaoEmailResponse";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

export const useGetConfiguracaoSmtpPadrao = (email: string) => {
  return useQuery<Cond21CloudResponse<ConfiguracaoEmailResponse>>({
    queryKey: ["configuracao-smtp-padrao", email],
    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<ConfiguracaoEmailResponse>>(
        api.groupPay.getConfiguracaoSmtpPadrao + email
      );
      return response.data;
    },
    enabled: !!email,    
  });
};